import { render, staticRenderFns } from "./ListDepartment.vue?vue&type=template&id=fcd613c0&scoped=true&"
import script from "./ListDepartment.vue?vue&type=script&lang=js&"
export * from "./ListDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ListDepartment.vue?vue&type=style&index=0&id=fcd613c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd613c0",
  null
  
)

export default component.exports